
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { retrieveDisclosure } from "../../Services/DisclosureApiService";
import $ from "jquery";
import '../../Components/Ticker/style.css';
import { Link } from "react-router-dom";
import { useAuthHeader } from "../../auth/AuthService";
require('../../Components/Ticker/script.js');

export default function Footer() {
    return (
        <>
            <div className="py-6"></div>
            <Ticker />
        </>
        
    );
}


function Ticker() {
    const [cookies, setCookie] = useCookies(['lang']);
    const [disclosures, setDisclosures] = useState([]);
    const authHeader = useAuthHeader();

    async function getDisclosure() {
        await retrieveDisclosure(cookies.lang, authHeader())
        .then((response) => {
            setDisclosures(response.data.data);
        })
        .catch((error) => console.log(error))

    }

    useEffect(() => {
        getDisclosure();
    }, [cookies.lang])

    useEffect(() => {
        if (disclosures.length > 0) {
            $('.js-newsticker').dropdown();
        }
    }, [disclosures.length]);

    return (
        <div className="grid hidden-print">
            <div className="newsticker js-newsticker w-full">
                <div className="ticker-container py-1">
                    <ul className="js-frame pl-2">
                        <span className="fw-bold">LATEST : </span>
                        {disclosures.map((disclosure, index) => <li className="js-item ms-3" key={index}><strong><Link className="ticker-link" to={`/disclosures/`+disclosure.id}>{disclosure.dtdcontents}</Link></strong></li>)}
                    </ul>
                </div>
                <ul id="ticker-controls" className="ticker-controls pt-0">
                    <li id="play-pause" className="jnt-play-pause controls">
                        <a href=""></a>
                    </li>
                    <li id="prev" className="jnt-prev controls">
                        <a href=""> </a>
                    </li>
                    <li id="next" className="jnt-next controls">
                        <a href=""> </a>
                    </li>
                </ul>
            </div>
        </div>
    );
}